import React from 'react';
import { motion } from 'framer-motion';
import { CONSTANTS } from '../data.js';

type CreditsPopupProps = {
  onClose: () => void;
};

export const CreditsPopup: React.FC<CreditsPopupProps> = ({ onClose }) => {
  return (
    <motion.div
      className="absolute inset-0 flex items-center justify-center z-50"
      style={{ background: 'rgba(26, 22, 17, 0.85)' }}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
    >
      <motion.div
        className="relative flex flex-col p-8 w-[500px] max-w-[90vw] rounded-xl"
        style={{
          background: `linear-gradient(135deg, ${CONSTANTS.ui.theme.colors.surface} 0%, ${CONSTANTS.ui.theme.colors.background} 100%)`,
          border: `2px solid ${CONSTANTS.ui.theme.colors.border}`,
          boxShadow: CONSTANTS.ui.theme.effects.ornateBoxShadow
        }}
        initial={{ scale: 0.9, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        exit={{ scale: 0.9, opacity: 0 }}
        transition={{ duration: 0.2 }}
      >
        {/* Decorative corners */}
        <div className="absolute top-3 left-3 w-6 h-6 border-l-2 border-t-2 rounded-tl-lg" style={{ borderColor: CONSTANTS.ui.theme.colors.primary }} />
        <div className="absolute top-3 right-3 w-6 h-6 border-r-2 border-t-2 rounded-tr-lg" style={{ borderColor: CONSTANTS.ui.theme.colors.primary }} />
        <div className="absolute bottom-3 left-3 w-6 h-6 border-l-2 border-b-2 rounded-bl-lg" style={{ borderColor: CONSTANTS.ui.theme.colors.primary }} />
        <div className="absolute bottom-3 right-3 w-6 h-6 border-r-2 border-b-2 rounded-br-lg" style={{ borderColor: CONSTANTS.ui.theme.colors.primary }} />

        <h2 
          className="font-cinzel text-3xl font-bold mb-6 text-center"
          style={{ 
            color: CONSTANTS.ui.theme.colors.primary,
            textShadow: CONSTANTS.ui.theme.effects.textGlow
          }}
        >
          Credits
        </h2>

        <div className="mb-6">
          <h3 
            className="font-cinzel text-xl font-bold mb-4"
            style={{ color: CONSTANTS.ui.theme.colors.text }}
          >
            Music Credits
          </h3>
          <div className="space-y-2">
            {CONSTANTS.credits.music.map((artist, index) => (
              <div 
                key={index}
                className="font-crimson text-base"
                style={{ color: CONSTANTS.ui.theme.colors.textSecondary }}
              >
                • {artist}
              </div>
            ))}
          </div>
        </div>

        <div className="mb-8">
          <p 
            className="font-crimson text-sm text-center italic"
            style={{ color: CONSTANTS.ui.theme.colors.textSecondary }}
          >
            Thank you to all the talented musicians who contributed to the atmospheric soundscape of Time Alchemist.
          </p>
        </div>

        <button
          onClick={onClose}
          className="font-crimson w-full px-8 py-3 rounded-lg text-lg font-semibold transition-all duration-200 hover:scale-105 active:scale-95"
          style={{
            background: `linear-gradient(135deg, ${CONSTANTS.ui.theme.colors.primary} 0%, ${CONSTANTS.ui.theme.colors.accent} 100%)`,
            color: CONSTANTS.ui.theme.colors.background,
            border: `2px solid ${CONSTANTS.ui.theme.colors.border}`,
            boxShadow: CONSTANTS.ui.theme.effects.ornateBoxShadow
          }}
        >
          Return to Quest
        </button>
      </motion.div>
    </motion.div>
  );
};
